import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { AppBar, useMediaQuery } from '@mui/material'
import { string } from 'prop-types'
import useSWR from 'swr'
import paths from '../../../paths/path'
import NavigationBarDesktop from '../NavigationBarDesktop'
import NavigationBarMobile from '../NavigationBarMobile'
import PartnershipBarDesktop from '../PartnershipBarDesktop'

export default function Header({ testId = 'header', style = {} }) {
  const fetcher = (url) => fetch(url).then((res) => res.json())
  const { data, error } = useSWR(`/api/get-search-categories`, fetcher)
  const mobileView = useMediaQuery((theme) =>
    theme.breakpoints.down('mobileCutoff')
  )
  const router = useRouter()
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [searchPopover, setSearchPopover] = useState(false)
  const [searchPopoverValue, setSearchPopoverValue] = useState('')
  const [topics, setTopics] = useState([])

  if (error) {
    console.error(error)
  }

  useEffect(() => {
    if (data) {
      setTopics(data.topics)
    }
  }, [data])

  const selectedTopics = topics?.filter((currentElement) => {
    return currentElement.onHomePage === true
  })

  const openSearchPopover = () => {
    setSearchPopover(true)
  }

  const closeSearchPopover = () => {
    setSearchPopover(false)
  }

  const triggerSearch = () => {
    setSearchPopover(false)
    router.push(
      paths.search({
        query: searchPopoverValue || '',
      })
    )
  }

  const onEnterKeyPress = (event) => {
    if (event.key === 'Enter') {
      triggerSearch()
    }
  }

  return (
    <AppBar
      elevation={0}
      sx={{
        bgcolor: 'background.light',
        height: {
          xs: '56px',
          md: '116px',
        },
        color: 'text.primary',
        borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
        ...style,
      }}
      data-testid={testId}
    >
      {mobileView ? (
        <>
          <NavigationBarMobile
            testId={`${testId}-mobile`}
            drawerOpen={drawerOpen}
            setDrawerOpen={setDrawerOpen}
            openSearchPopover={openSearchPopover}
            searchPopover={searchPopover}
            closeSearchPopover={closeSearchPopover}
            searchPopoverValue={searchPopoverValue}
            setSearchPopoverValue={setSearchPopoverValue}
            triggerSearch={triggerSearch}
            onEnterKeyPress={onEnterKeyPress}
            selectedTopics={selectedTopics}
          />
        </>
      ) : (
        <>
          <PartnershipBarDesktop testId={`partnership-${testId}-desktop`} />
          <NavigationBarDesktop
            testId={`${testId}-desktop`}
            openSearchPopover={openSearchPopover}
            searchPopover={searchPopover}
            closeSearchPopover={closeSearchPopover}
            searchPopoverValue={searchPopoverValue}
            setSearchPopoverValue={setSearchPopoverValue}
            triggerSearch={triggerSearch}
            onEnterKeyPress={onEnterKeyPress}
            selectedTopics={selectedTopics}
          />
        </>
      )}
    </AppBar>
  )
}

Header.propTypes = {
  testId: string,
  style: Object | null,
}
